import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { TrendingUp } from "lucide-react";


const PerformanceTrend = ( props ) => {
  const { } = props;

  	return (
        <HeaderComponent
          title="Performance Trend"
          labelIcon={<TrendingUp size={20}/>}
          description="Monthly performance scores over time"
        >
        </HeaderComponent>
);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceTrend);
